import dJSON from 'dirty-json';

/**
 * Module Init
 */
(() => {
  const moduleSelector = '.info-cards';
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((query) => {
    try {
      query.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(query.data);

      data.forEach((item) => {
        query.insertAdjacentHTML('beforeend', /* html */ `
          <a href="${item.linkUrl}" class="info-card ${item.cardType}">
            <div class="image-wrapper">
              <img src="${item.background}" alt="">
            </div>
            <div class="content-wrapper">
              ${item.kicker ? `<p class="kicker">${item.kicker}</p>` : ''}
              ${item.title ? `<h3 class="title">${item.title}</h3>` : ''}
              ${item.description ? `<p class="description">${item.description}</p>` : ''}
              ${item.link ? `<p class="link">${item.link}</p>` : ''}
            </div>
          </a>
        `);
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
